import classNames from 'classnames';
import { CustomLayoutProps } from '../../../interfaces';
import { ContentOnlyWrapper } from './styles';
import './styles.scss';

const ContentOnlyLayout: React.FC<CustomLayoutProps> = props => {
  const { className, sider, header, ...rest } = props;

  return (
    <ContentOnlyWrapper
      {...rest}
      className={classNames(className, 'without-all-layout')}
    />
  );
};

export default ContentOnlyLayout;
